module.exports = __webpack_public_path__ + "img/1.2dff2d93.jpg";